<template>
  <div v-bind:class="{ rightMenuOpened: menuDefState}"
    class="rightMenu fCol jStart aCenter">
    <!-- first item -->
    <div class="firstItem fRow jStart aCenter primary"
      @click="toggleMenu">
      <div class="fCol growFull jStart aStart">
        <div :class="`${appName.name}Logo`"></div>
      </div>
      <div class="menuBtn" v-bind:class="{ open: menuDefState}"></div>
    </div>
    <!-- dynamic menus -->
    <ul class="menu fCol jStart aCenter fullWidth">
      <li class="item parent fullWidth fRow jStart aCenter"
        v-bind:class="{active: item.route === activeUrl}"
        @click="goTo(item.route)"
        v-for="(item, index) in menu"
        v-bind:key="index">
        <span class="growFull">{{item.title}}</span>
        <i class="material-icons-round transition-medium icon">{{item.icon}}
          <div class="tooltip secondary transition-fast fRow jCenter aCenter"
            v-if="!menuDefState">{{item.title}}</div>
        </i>
      </li>
    </ul>
    <ul class="menuHolder growFull jStart aCenter fCol" v-if="false">
      <li class="item fRow jBetween aCenter fullWidth"
        v-for="(item, indx) in menu" v-bind:key="indx"
        @click="goTo(item.route)">
        <label>{{item.title}}</label>
        <i class="material-icons-round">{{item.icon}}</i>
      </li>
      <div class="fCol jStart aCenter fullWidth" v-if="false">
        <menu-item
          label="تعریف دسترسی‌ها"
          icon="tune"
          path="/access"
          step="1"
        />
        <menu-item
          label="تعریف کاربر سیستم"
          icon="person_add_alt"
          path="/user"
          step="1"
        />
        <menu-item
          label="تفاهم‌نامه"
          icon="assignment"
          path="/assignment"
          step="1"
        />
        <menu-item
          label="حسابداری"
          icon="paid"
          path="/accounting"
          step="1"
        />
        <menu-item
          label="مؤسسه ها"
          icon="business"
          path="/institutes"
          step="1"
        />
        <menu-item
          label="رشته ها"
          icon="category"
          path="/fields"
          step="1"
        />
        <menu-item
          label="پایه ها"
          icon="clear_all"
          path="/grades"
          step="1"
        />
        <menu-item
          label="درس ها"
          icon="menu_book"
          path="/lessons"
          step="1"
        />
        <menu-item
          label="کلاس"
          icon="class"
          path="/class"
          step="1"
        />
        <menu-item
          label="دبیران"
          icon="school"
          path="/teachers"
          step="1"
        />
        <menu-item
          label="دوره‌ها"
          icon="ondemand_video"
          path="/courses"
          step="1"
        />
        <menu-item
          label="آزمون‌ها"
          icon="check_box"
          path="/exams"
          step="1"
        />
        <menu-item
          label="فروشگاه"
          icon="shopping_cart"
          path="/shop"
          step="1"
        />
        <menu-item
          label="مدیریت بازی"
          icon="emoji_events"
          path="/game"
          step="1"
        />
      </div>
      <div @click="openMenu('settings')" data-opened="0" id="settings"
        v-if="false"
        class="fCol jStart aStart fullWidth itemGroup"></div>
    </ul>
  </div>
</template>

<script>
import MenuItem from '@/components/MenuItem.vue';
import axios from 'axios';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';

export default {
  name: 'right-menu',
  mixins: [errorHandler, makeToast],
  data() {
    return {
      isAnyItemOpened: false,
      openedGroup: '',
      menuDefState: false,
      menuSeen: false,
      menu: [
        {
          title: 'داشبورد',
          route: '/dashboard',
          icon: 'dashboard',
          sub: [],
        },
        {
          title: 'تعریف دسترسی‌ها',
          route: '/access',
          icon: 'tune',
          sub: [],
        },
        {
          title: 'مشاورین',
          route: '/moshavers',
          icon: 'support_agent',
          sub: [],
        },
        {
          title: 'سنجش مشاورین',
          route: '/rating',
          icon: 'thumbs_up_down',
          sub: [],
        },
        // {
        //   title: 'برنامه درسی',
        //   route: '/homework',
        //   icon: 'pending_actions',
        //   sub: [],
        // },
        {
          title: 'شبکه اجتماعی',
          route: '/social',
          icon: 'groups',
          sub: [],
        },
        {
          title: 'پیام کاربران',
          route: '/tickets',
          icon: 'confirmation_number',
          sub: [],
        },
        // {
        //   title: 'تعریف کاربر سیستم',
        //   route: '/user',
        //   icon: 'person_add_alt',
        //   sub: [],
        // },
        {
          title: 'تفاهم نامه',
          route: '/assignment',
          icon: 'assignment',
          sub: [],
        },
        {
          title: 'حسابداری',
          route: '/accounting',
          icon: 'paid',
          sub: [],
        },
        {
          title: 'مؤسسه ها',
          route: '/institutes',
          icon: 'business',
          sub: [],
        },
        {
          title: 'رشته ها',
          route: '/fields',
          icon: 'category',
          sub: [],
        },
        {
          title: 'پایه ها',
          route: '/grades',
          icon: 'clear_all',
          sub: [],
        },
        {
          title: 'درس ها',
          route: '/lessons',
          icon: 'menu_book',
          sub: [],
        },
        {
          title: 'دبیران',
          route: '/teachers',
          icon: 'school',
          sub: [],
        },
        {
          title: 'کلاس',
          route: '/class',
          icon: 'class',
          sub: [],
        },
        {
          title: 'دوره ها',
          route: '/courses',
          icon: 'ondemand_video',
          sub: [],
        },
        {
          title: 'آزمون‌ها',
          route: '/exams',
          icon: 'check_box',
          sub: [],
        },
        {
          title: 'برنامه‌های ویژه',
          route: '/extra',
          icon: 'star',
          sub: [],
        },
      ],
      menus: [],
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
    };
  },
  components: {
    MenuItem,
  },
  props: ['open'],
  computed: {
    appName() {
      return this.$store.state.appName;
    },
    activeUrl() {
      const queryObj = this.$router.currentRoute.path;
      return queryObj;
    },
  },
  methods: {
    setMode(m, msg) {
      this.noContent = false;
      this.loading = false;
      this.notYet = false;
      this.error = false;
      this.loaded = false;
      this.modeMsg = '';
      switch (m) {
        case 'loading': {
          this.loading = true;
          break;
        }
        case 'loaded': {
          this.loaded = true;
          break;
        }
        case 'error': {
          this.modeMsg = msg;
          this.error = true;
          break;
        }
        case 'notYet': {
          this.notYet = true;
          break;
        }
        case 'noContent': {
          this.noContent = true;
          break;
        }
        default:
          break;
      }
    },
    openMenu(igId) {
      const ig = document.getElementById(igId);
      const pig = document.getElementById(this.openedGroup);
      if (ig.getAttribute('data-opened') === '0') {
        if (this.openedGroup !== '') {
          pig.setAttribute('data-opened', '0');
          pig.style.height = '56px';
          pig.style.background = 'rgba(0,0,0,0)';
        }
        ig.setAttribute('data-opened', '1');
        ig.style.height = `${56 * ig.childElementCount}px`;
        ig.style.background = 'rgba(0,0,0,0.2)';
        this.openedGroup = igId;
        this.isAnyItemOpened = true;
        // console.log(this.openedGroup, window.location.pathname);
      }
    },
    firstHover() {
      setTimeout(() => {
        this.menuDefState = false;
      }, 200);
    },
    toggleMenu() {
      this.menuDefState = !this.menuDefState;
    },
    goTo(r) {
      this.menuDefState = false;
      this.$router.push(r);
    },
    getUserAccess() {
      axios({
        method: 'get',
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
        url: `${this.baseURL}/api/v${this.V}/Members/access`,
      }).then((response) => {
        const re = response.data.data;
        if (response.data.isSuccess && false) {
          this.menu = [];
          for (let i = 0; i < re.length; i += 1) {
            const a = {
              title: re[i][0].parent.title,
              route: re[i][0].parent.localPath,
              icon: re[i][0].parent.icon,
            };
            this.menu.push(a);
          }
          console.log(this.menu);
          // this.expandRow();
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
      });
      // if (this.$store.state.letExpand) {
      //   // اگر بسته بود
      //   if (this.expanded === false) {
      //     // اگر زیر مجموعه داست
      //     this.whileLoading = true;
      //   } else {
      //     this.expandRow();
      //   }
      // }
    },
  },
  watch: {
    $router() {
      // console.log(from, to);
      console.log(this.activeUrl);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.getUserAccess();
      console.log(this.activeUrl);
    });
    // this.$store.commit('mamadPlus');
  },
};
</script>

<style lang="scss" scoped>

  .itemGroup{
    height: 56px;
    overflow: hidden;
    transition: all cubic-bezier(0.5,0,0,1) 0.5s;
  }

  .itemGroup:focus{
    background-color: rgba(0,0,0,0.2);
  }

  #users:focus{
    height: 224px;
  }

  #sale:focus, #support:focus, #settings:focus{
    height: 168px;
  }

  ul.menu {
    padding: 0;
    margin: 0;
    $iconSize: 56px;
    li.item {
      cursor: pointer;
      list-style: none;
      background-color: var(--primary5);
      border-bottom: solid 1px var(--themeBlack1);
      span {
        color: var(--themeWhite);
        font-size: 12px;
        text-align: right;
        padding-right: 16px;
        z-index: 10;
        border-right: solid 4px var(--themeWhite35);
      }
      i {
        padding: 12px;
        color: var(--themeWhite);
        font-size: 16px;
        border-radius: 0 64px 64px 0;
        width: $iconSize;
        z-index: 8;
        position: relative;
        .tooltip {
          position: absolute;
          right: 100%;
          top: 50%;
          height: 100%;
          padding: 0 16px;
          white-space: nowrap;
          border-radius: 50px 0 0 50px;
          transform: translateY(-50%) scale(0);
          transform-origin: right center;
          cursor: pointer;
          color: var(--themeWhite);
          font-size: 13px;
          font-weight: 300;
        }
      }
    }
    li.item.parent {
      span {
        margin-right: 0px;
      }
    }
    li.item:hover {
      background-color: var(--primary7);
      i {
        // box-shadow: 0 0 0 350px rgba($color: #000000, $alpha: 0.15);
        color: var(--themeWhite);
        .tooltip {
          transform: translateY(-50%) scale(1);
        }
      }
    }
    li.item.active {
      background-color: var(--secondary5);
    }
    li.item.active:hover {
      background-color: var(--secondary5);
      i {
        // box-shadow: 0 0 0 350px rgba($color: #000000, $alpha: 0.15);
        color: var(--themeWhite);
        .tooltip {
          transform: translateY(-50%) scale(1);
        }
      }
    }
  }
</style>
